import React, { Component, useState } from "react";
import trash from "src/images/trash.svg";
import {
  ITEM_CUSTOM_ATTR_OPTIONS,
  CUSTOM_ATTR_NA,
} from "src/util/PrioritizeUtil";
import _ from "lodash";
import collectionApi from "src/api/v2/CollectionApi";
import { Input } from "src/components/shared";

export default class Initiative extends Component {
  getItemCostPlaceholder = (value) => {
    const names = _.find(ITEM_CUSTOM_ATTR_OPTIONS, ["value", value]) || {};
    return `${names && names.placeholder}`;
  };

  onItemBlur = (event) => {
    if (!this.props.collection.id || !event.target.value.trim()) return;

    const idToUpdate = this.props.subCollections[this.props.idx]
      ? this.props.subCollections[this.props.idx].id
      : null;
    if (idToUpdate) {
      collectionApi.update({
        ...this.props.subCollections[this.props.idx],
        sort_order: this.props.idx,
      });
    } else {
      const newItems = [
        {
          ...this.props.subCollections[this.props.idx],
          collection_type: "prioritize-item",
          sort_order: this.props.idx,
        },
      ];

      collectionApi
        .createChildren(this.props.collection.id, newItems)
        .then((newItemCollections) => {
          // set ID on the item
          const newItemCollection = newItemCollections[0];
          const subCollections = [...this.props.subCollections];

          subCollections[this.props.idx].id = newItemCollection.id;
          subCollections[this.props.idx].collection_type = "prioritize-item";

          this.props.onStateChange("subCollections", subCollections);
        });
    }
  };

  onTabPress = (isLast) => ({ keyCode }) => {
    if (keyCode === 9 && isLast) {
      this.props.onItemAdd();
    }
  };

  onItemRemove = (arrayHelpers, idx, collection) => () => {
    arrayHelpers.remove(idx);
    if (collection.id) collectionApi.delete(collection.id);
  };

  render() {
    const {
      idx,
      collection,
      setFieldValue,
      isLast,
      arrayHelpers,
      onPaste,
      custom_attr_1,
    } = this.props;

    return (
      <div
        className="create-step1__grid create-step1__list_item"
        key={idx}
        onPaste={onPaste(idx)}
      >
        <div className="item-index create-step1__icon index mr-1">
          <span>{idx + 1}</span>
        </div>
        <div>
          <Input
            className="create-step1__input_left"
            placeholder={"Item name"}
            onChange={({ target }) => setFieldValue(idx, "title", target.value)}
            // onBlur={this.onItemBlur}
            value={collection.title}
          />
          <ItemDetails
            onChange={({ target }) =>
              setFieldValue(idx, "description", target.value)
            }
            value={collection.description}
          />
        </div>
        <Input
          className="create-step1__input_right"
          placeholder={this.getItemCostPlaceholder(custom_attr_1)}
          onChange={({ target }) =>
            setFieldValue(idx, "custom_attr_1", target.value)
          }
          // onBlur={this.onItemBlur}
          onKeyDown={this.onTabPress(isLast)}
          value={collection.custom_attr_1}
          disabled={collection.custom_attr_1 === CUSTOM_ATTR_NA}
        />
        <button
          className="btn btn-sm btn-remove ml-2 create-step1__icon trash"
          type="button"
          onClick={this.onItemRemove(arrayHelpers, idx, collection)}
          tabIndex="-1"
        >
          <img src={trash} alt="trash" />
        </button>
      </div>
    );

    
    
    

  }
  
}

const ItemDetails = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const onExpand = () => {
    setIsOpen(true);
  };
  const onClear = () => {
    setIsOpen(false);
    onChange({ target: { value: null } });
  };
  return (
    <div className="item-details">
      {!(value || isOpen) && (
        <button className="btn btn-flat btn-add-details" onClick={onExpand}>
          Add details
        </button>
      )}
      {(value || isOpen) && (
        <div className="item-details-row">
          <textarea
            className="form-control"
            cols="150"
            rows="3"
            maxLength="1000"
            placeholder="Item details"
            onChange={onChange}
            value={value}
          ></textarea>
          <button
            className="btn btn-sm btn-remove trash"
            type="button"
            onClick={onClear}
            tabIndex="-1"
          >
            <img src={trash} alt="trash" />
          </button>
        </div>
      )}
    </div>
  );
};
